import {NotificationTypes, DeliveryTypes} from '../globals/Constants';

interface NotificationSettingsModel {
   eventType: NotificationTypes;
   deliveryType: DeliveryTypes;
   enabled: boolean;
}

export const nullNotificationSettingsModelFactory = (initialData?: Partial<NotificationSettingsModel>): NotificationSettingsModel => Object.assign({
   eventType: NotificationTypes.NewComment,
   deliveryType: DeliveryTypes.Email,
   enabled: true
}, initialData);

export const filterNotificationSetting = (notificationSettings: NotificationSettingsModel[], notificationType: NotificationTypes): NotificationSettingsModel =>
   notificationSettings?.find(setting => setting.eventType.toString().toLowerCase() === notificationType.toString().toLowerCase() && setting.deliveryType === DeliveryTypes.Email) ?? nullNotificationSettingsModelFactory({eventType: notificationType});

export default NotificationSettingsModel;
